@if (isShow) {
  <section class="alert">
    <section class="alert-contenido">
      @if (alert.onXButton) {
        <div class="text-right font-gr_bold">
          <button (click)="cancel()">X</button>
        </div>
      }
      @if (alert.type !== "loader" && alert.type !== "answer") {
        <div class="alert-icono">
          <section class="alert-{{ alert.type }}">
            <div class="icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
              <div class="icon-fix"></div>
            </div>
          </section>
        </div>
      }
      @if (alert.type === "answer") {
        <section class="alert-answer">
          <div class="icon">
            <div class="icon-circle">
              <p>?</p>
            </div>
            <div class="icon-fix"></div>
          </div>
        </section>
      }
      @if (alert.title) {
        <div
          class="alert-titulo mb-3 text-xl font-bold"
          [innerHTML]="alert.title"
        ></div>
      }
      <div class="alert-mensaje" [innerHTML]="alert.message"></div>

      @if (alert.type === "loader") {
        <section class="alert-loader">
          <div class="loading"></div>
        </section>
      }
      @if (alert.type !== "loader") {
        <section
          class="alert-acciones"
          (click)="accept()"
          (keydown)="handleKeyDown($event)"
        >
          @if (alert.type === "answer") {
            <button class="btn-danger" (click)="cancel()" autofocus>
              Cancelar
            </button>
          }
          <button autofocus class="boton">
            {{ alert.onXButton ? "Reintentar" : "Aceptar" }}
          </button>
        </section>
      }
    </section>
  </section>
}
